import { useEffect, useState } from "react";
import { Play, Loader2, Film } from "lucide-react";
import { videoPlayback } from "@/lib/videoApi";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function StreamPlayer({ src, title }) {
  return (
    <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
      <iframe data-testid="stream-player" title={title || "Video"} src={src} allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen className="absolute inset-0 w-full h-full border-0" />
    </div>
  );
}

// Thumbnail that opens the Cloudflare Stream player. Never renders a player until Cloudflare says it's playable.
export function StreamThumb({ videoId, token, name, ready = true, inline = false, className = "aspect-[4/3]" }) {
  const [pb, setPb] = useState(null);
  const [err, setErr] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!ready) return;
    videoPlayback(videoId, token).then(setPb).catch((e) => setErr(e.message));
  }, [videoId, token, ready]);
  if (!ready || err) return (
    <div data-testid={`video-processing-${videoId}`} className={`w-full ${className} flex flex-col items-center justify-center gap-1 bg-stone-800 text-stone-200 text-xs text-center p-2`}>
      <Film className="h-6 w-6" />{err ? "Video unavailable" : "Processing — this can take a few minutes"}
    </div>
  );
  if (!pb) return <div className={`w-full ${className} flex items-center justify-center bg-stone-800`}><Loader2 className="h-5 w-5 animate-spin text-stone-300" /></div>;
  if (inline) return <StreamPlayer src={pb.iframe} title={name} />;
  return (
    <>
      <button type="button" data-testid={`video-thumb-${videoId}`} onClick={(e) => { e.stopPropagation(); setOpen(true); }} aria-label={`Play ${name || "video"}`} className={`relative block w-full ${className} bg-black group`}>
        <img src={pb.thumbnail} alt={name || "Video thumbnail"} className="w-full h-full object-cover" />
        <span className="absolute inset-0 flex items-center justify-center"><span className="h-12 w-12 rounded-full bg-black/60 flex items-center justify-center group-hover:bg-black/80"><Play className="h-6 w-6 text-white ml-0.5" /></span></span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="video-player-dialog" className="w-[calc(100%-1rem)] max-w-3xl p-2 sm:p-3">
          <DialogTitle className="sr-only">{name || "Video"}</DialogTitle>
          <DialogDescription className="sr-only">Video player</DialogDescription>
          {open && <StreamPlayer src={pb.iframe} title={name} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
